import React from 'react';
import { Input } from 'reactstrap';
import { FieldProps } from 'formik';

type OwnProps = FieldProps<any>

export const TextInput: React.SFC<OwnProps> = ({ field: { ...fields }, form: { touched, errors, ...rest }, ...props }) => {
  return <Input type="text" {...fields} {...props} />
}